import React, { useContext, useState } from 'react';
import { MainContext } from '../../context/MainContext';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';
import DynamicSelect from '../resources/DynamicSelect';
import * as Constants from '../../components/api/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

const typeData = [
  { id: '1', name: 'SV2' },
  { id: '2', name: 'SV3' },
  { id: '3', name: 'SV4' },
  { id: '4', name: 'SM1' },
  { id: '5', name: 'SM2' },
];

const tmaxData = [];
let t = 28.0;
let tId = 1;
while (t <= 41.2) {
  tmaxData.push({ id: tId++, name: t.toFixed(1) });
  t += 0.2;
}

const elementData = [{ id: '1', name: '1' }, { id: '2', name: '2' }];
const brandData = [
  { id: '1', name: 'SPAN' }, { id: '2', name: 'SAPP' }, { id: '3', name: 'VORT' },
  { id: '4', name: 'COAS' }, { id: '5', name: 'OASI' }, { id: '6', name: 'SPF' },
  { id: '7', name: 'AUST' }, { id: '8', name: 'ALPN' }, { id: '9', name: 'VOLI' },
  { id: '10', name: 'TFRM' }, { id: '11', name: 'ROTO' }, { id: '12', name: 'MAGN' },
];
const onOffData = [{ id: '1', name: 'On' }, { id: '2', name: 'Off' }];

export default function EEPROMOptionsMenu() {
  const state = useContext(MainContext).state;
  const r3 = state.R3.split(',');
  const r6 = state.R6.split(',');
  const rc = state.RC.split(',');
  const deviceId = state.selectedDevice;

  const [selectedValues, setSelectedValues] = useState({});

  const handleSelectChange = (id, value) => {
    setSelectedValues((prev) => ({ ...prev, [id]: value }));
  };

  const sendCommand = (command, value) => {
    fetch(Constants.baseURL + Constants.apiSendCommand, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ DeviceId: deviceId, Command: command, Value: String(value) }),
      credentials: 'include',
    })
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', { position: 'top-right', autoClose: 10000 });
          setTimeout(() => state.refreshDeviceRF(deviceId), 6000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 12000);
        } else {
          toast.error('Send failed. Please try again', { position: 'top-right', autoClose: 5000 });
        }
      })
      .catch((err) => console.log('request failed', err));
  };

  const handleSend = (id) => {
    const value = selectedValues[id];
    if (value === undefined || value === '') return;

    switch (id) {
      case 0: sendCommand('type', value); break;
      case 1: sendCommand('TMax', value); break;
      case 2: sendCommand('elements', value); break;
      case 3: sendCommand('brand', value); break;
      case 4: sendCommand('vpmp', value); break;
      case 5: sendCommand('hifi', value); break;
      case 6: sendCommand('hsig', value); break;
      case 7: sendCommand('oxy', value); break;
      default: break;
    }
  };

  const clearDataOnClick = () => sendCommand('clearData', '');
  const eepromResetOnClick = () => sendCommand('eepromReset', '');

  let typeLabel = 'N/A';
  if (r6[26] === '2') typeLabel = 'SV2';
  if (r6[26] === '3') typeLabel = 'SV3';
  if (r6[26] === '4') typeLabel = 'SV4';
  if (r6[26] === '5') typeLabel = 'SM1';
  if (r6[26] === '6') typeLabel = 'SM2';

  const tmaxLabel = (r6[28] / 10.0).toFixed(1);
  let elementsLabel = r6[25] === '0' ? '1' : r6[25];

  const brandMap = ['SPAN', 'SAPP', 'VORT', 'COAS', 'OASI', 'SPF', 'AUST', 'ALPN', 'VOLI', 'TFRM', 'ROTO', 'MAGN'];
  let brandLabel = 'N/A';
  const brandIndex = Number(r6[23]);
  if (!Number.isNaN(brandIndex) && brandIndex >= 0 && brandIndex < brandMap.length) brandLabel = brandMap[brandIndex];

  const vpmpLabel = r6[21] === '1' ? 'On' : 'Off';
  const hifiLabel = r6[22] === '1' ? 'On' : 'Off';
  const hsigLabel = r3[28] === '1' ? 'On' : 'Off';
  const oxyLabel = rc[16] === '1' ? 'On' : 'Off';

  const rows = [
    { id: 0, label: 'Type', current: typeLabel, selectData: typeData },
    { id: 1, label: 'T.MAX', current: tmaxLabel, selectData: tmaxData },
    { id: 2, label: 'Elements', current: elementsLabel, selectData: elementData },
    { id: 3, label: 'Brand', current: brandLabel, selectData: brandData },
    { id: 4, label: 'VPMP', current: vpmpLabel, selectData: onOffData },
    { id: 5, label: 'HIFI', current: hifiLabel, selectData: onOffData },
    { id: 6, label: 'H.SIG', current: hsigLabel, selectData: onOffData },
    { id: 7, label: 'OXY', current: oxyLabel, selectData: onOffData },
  ];

  const EEPROM_TOOLTIPS = {
    Type: 'Device type',
    'T.MAX': 'Maximum set temperature',
    Elements: '',
    Brand: 'Spa Brand',
    VPMP: 'Variable pump',
    HIFI: 'Sony stereo enable/disable',
    'H.SIG': 'Heat Signal (SSIG V1)',
    OXY: 'Micro Bubble Pump',
  };

  return (
    <>
      <Typography component="h2" variant="h6" sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
        Options Menu
      </Typography>

      <Grid container spacing={2}>
        {rows.map((row) => (
          <Grid item xs={12} md={6} lg={6} key={row.id}>
            <Paper
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.2,
                position: 'relative', // needed for top-right label
              }}
            >
              {/* Label and tooltip text */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: 1.1,
                  }}
                >
                  {row.label}
                </Typography>

                {EEPROM_TOOLTIPS[row.label] && (
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: 'white',
                      lineHeight: 1.1,
                      ml: 1,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {EEPROM_TOOLTIPS[row.label]}
                  </Typography>
                )}
              </Box>

              <Typography
                variant="caption"
                sx={{
                  fontSize: 13,
                  color: 'text.disabled',
                }}
              >
                {row.current}
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'stretch',
                  flexDirection: { xs: 'column', md: 'row' },
                  width: '100%',
                  minWidth: 0,

                  '--control-h': { xs: '44px', md: '44px' },

                  '& .MuiInputBase-root': { height: 'var(--control-h)' },
                  '& .MuiSelect-select': {
                    height: 'var(--control-h)',
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: 0,
                    paddingBottom: 0,
                  },
                  '& .MuiFormControl-root': { width: '100%', minWidth: 0 },

                  mt: 1,
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <DynamicSelect
                    arrayOfData={row.selectData}
                    onSelectChange={(val) => handleSelectChange(row.id, val)}
                    id={row.id}
                    name=""
                  />
                </Box>

                {selectedValues[row.id] !== undefined && selectedValues[row.id] !== '' && (
                  <Button
                    onClick={() => handleSend(row.id)}
                    variant="outlined"
                    size="small"
                    sx={{
                      height: 'var(--control-h)',
                      minHeight: 'var(--control-h)',
                      textTransform: 'none',
                      fontWeight: 600,
                      borderColor: 'rgba(255,255,255,0.3)',
                      color: 'white',
                      px: 1.5,
                      width: { xs: '100%', md: 'auto' },
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        borderColor: 'white',
                        backgroundColor: 'rgba(255,255,255,0.08)',
                      },
                    }}
                  >
                    Send
                  </Button>
                )}
              </Box>
            </Paper>
          </Grid>
        ))}

        {/* Controls */}
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mt: 1, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 600, mb: 1.5 }}>
              Controls
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Button
                variant="outlined"
                onClick={clearDataOnClick}
                sx={{ width: '100%', color: 'white', borderColor: 'rgba(255,255,255,0.35)', textTransform: 'none', '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.08)' } }}
              >
                Clear Data
              </Button>

              <Button
                variant="contained"
                onClick={eepromResetOnClick}
                sx={{ width: '100%', textTransform: 'none', color: 'white', bgcolor: '#f44336', '&:hover': { bgcolor: '#d32f2f' } }}
              >
                EEPROM Reset
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
